import './orders.css'
import React from 'react'
import { connect } from 'react-redux'
import {
    getOrdersAction,
    getGroupReadyForCollectAction,
    getOrdersForExportAction,
    downloadOrderAction,
    getStatusAction,
} from '../../../actions/appActions'
import moment from 'moment'
import {
    Button,
    TextField,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Typography
} from '@material-ui/core/index'
import { strings } from '../../../localization/strings'
import GridList from './gridList'
import routes from '../../router/routes'
import Loader from '../../loaders'
import WarningIcon from '@material-ui/icons/Warning'
import {
    getObjectKey,
    orderStateTypes,
    orderTypes,
    statusTypes,
} from '../../../server/shared'
import InfoIcon from '@material-ui/icons/Info'
import withStyles from '@material-ui/core/styles/withStyles'
import Tooltip from '@material-ui/core/Tooltip'
import { saveAsExcel } from '../../components/saveAsExcel'
import { exportOrdersTemplate, exportOrdersHeaders } from './orderTemplates'
import { orderReadyAll } from '../../../helpers/restHelpers'

const TooltipFontSizeMedium = withStyles({
    tooltip: {
        fontSize: '0.8em',
    },
})(Tooltip)

const styles = {
    field: {
        maxWidth: 200,
        height: 64,
        padding: 2,
        margin: '10px',
    },
    btnContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    formBtn: {
        minWidth: '200px',
        maxWidth: 'fit-content',
        height: '32px',
        margin: '10px',
    },
}

export const orderStatesFilter = [
    orderStateTypes.registered,
    orderStateTypes.pendingIncidentResolution,
    orderStateTypes.reserved,
    orderStateTypes.waitingPickup,
    orderStateTypes.orderWaitingPickUpLimit,
    orderStateTypes.pendingReservation,
    orderStateTypes.customerPickup,
    orderStateTypes.abandoned,
    orderStateTypes.abandonedCollected,
    orderStateTypes.deposited,
    orderStateTypes.depositExpired,
    orderStateTypes.parcelCollected,
    orderStateTypes.inFacility,
    orderStateTypes.inTransit,
    orderStateTypes.cancelled,
    orderStateTypes.returnToSender,
    orderStateTypes.outForDelivery,
    orderStateTypes.courierDelivered,
    orderStateTypes.lockerPickup,
    orderStateTypes.unableToPickup,
]

class Component extends React.Component {
    state = {
        fetching_orders: true,
        fromDate: moment().add(-7, 'days').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        orderNumber: '',
        rows: [],
        filteredOrders: [],
        totalRows: 0,
        fetching_pdf: false,
        status: '',
        orderCustomSecurity: this.props.appStore.userPermissions.some(
            (x) => x === 'orderCustomSecurity'
        ),
        ordersGroupedToReadyForCollect: [],
        readyForCollect: 0
    }

    getStatus = () =>
        new Promise((resolve, reject) => {
            this.props
                .getStatusAction(this.props.history)
                .then((status) => {
                    this.setState({ status: status })
                    resolve()
                })
                .catch((error) => {
                    if (error.additionalData)
                        window.showDialog(
                            { message: error.additionalData },
                            () => this.props.logOutAction()
                        )
                    else
                        window.showDialog(error, () =>
                            this.props.logOutAction()
                        )
                    reject()
                })
        })

    getOrders = (pageIndex, rowsPerPage) => {
        if (!pageIndex) pageIndex = this.state.paginatorPageIndex || 1
        if (!rowsPerPage)
            rowsPerPage =
                this.state.paginatorRowsPerPage ||
                localStorage.getItem('paginatorRowsPerPage') ||
                10

        this.setState({ fetching_orders: true })

        if (rowsPerPage !== this.state.paginatorRowsPerPage) {
            pageIndex = 1
            localStorage.setItem('paginatorRowsPerPage', rowsPerPage)
        }

        var data = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            orderNumber: this.state.orderNumber,
            pageIndex: pageIndex,
            pageSize: rowsPerPage,
            orderStateId: this.state.orderStateId || 0,
            orderTypeId: this.state.orderTypeId || 0,
        }

        this.props
            .getOrdersAction(data)
            .then((x) => {
                let rows = x.data
                    ? x.data.map((x) => ({ ...x, checked: false }))
                    : []
                let ordersWaitingPickUpLimit = rows.filter(x => x.isGroupedToReadyForCollect === true)
                let ordersCreated = rows.filter(x => x.isGroupedToReadyForCollect === false)

                if (this.state.orderStateId === 99) {
                    rows = ordersWaitingPickUpLimit
                } else if (this.state.orderStateId === 1) {
                    rows = ordersCreated
                }

                this.setState({
                    fetching_orders: false,
                    rows: rows,
                    totalRows: x.totalRows, //mock
                    paginatorRowsPerPage: rowsPerPage,
                    paginatorPageIndex: pageIndex,
                })
            })
            .catch((error) => {
                window.showDialog(error)
                this.setState({ fetching_orders: false })
            })
    }

    getGroupReadyForCollect = () => {
        this.props
            .getGroupReadyForCollectAction()
            .then((response) => {
                this.setState({ ordersGroupedToReadyForCollect: response.groupReady })
                this.setState({ readyForCollect: response.readyForCollect })
            })
    }
    getOrdersForExport = () => {
        var data = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            identifier: this.state.orderNumber,
            orderStateId: this.state.orderStateId || '',
            orderTypeId: this.state.orderTypeId || '',
        }
        this.setState({ fetching_orders: true })
        this.props
            .getOrdersForExportAction(data)
            .then((x) => {
                if (x !== null) {
                    x.forEach((x) => {
                        if (x.shippingMethod === 'Standard') {
                            x.shippingMethod = 'Smart Locker'
                        } else if (x.shippingMethod === 'ShipToAddress') {
                            x.shippingMethod = 'Envío a Domicilio'
                        }
                        x.insertionTS = moment(x.insertionTS).format('DD-MM-YYYY')
                        if (x.depositDate) x.depositDate = moment(x.depositDate).format('DD-MM-YYYY HH:mm')
                        if (x.collectedDate) x.collectedDate = moment(x.collectedDate).format('DD-MM-YYYY HH:mm')
                        if (x.expiredNotCollectedDate) x.expiredNotCollectedDate = moment(x.expiredNotCollectedDate).format('DD-MM-YYYY HH:mm')
                        if (x.abandonedCollectedDate) x.abandonedCollectedDate = moment(x.abandonedCollectedDate).format('DD-MM-YYYY HH:mm')
                        Object.keys(orderStateTypes).forEach((y) => {
                            if (x.orderStateName.charAt(0).toLowerCase() + x.orderStateName.slice(1) === y) {
                                x.orderStateName = strings.orderStateFilter[getObjectKey(orderStateTypes, x.orderStateId)]
                            }
                        })
                    })
                }
                this.setState({
                    fetching_orders: false,
                    filteredOrders: x
                })
                saveAsExcel(this.state.filteredOrders, 'Ordenes.xlsx', exportOrdersTemplate(this.state.orderCustomSecurity), exportOrdersHeaders(this.state.orderCustomSecurity), this.state.orderCustomSecurity)
            })
            .catch((error) => {
                window.showDialog(error)
                this.setState({ fetching_orders: false })
            })
    }

    getOrderLabel = (orderId, print) => {
        this.setState({ fetching_pdf: true })
        this.props
            .downloadOrderAction(orderId, print)
            .then(() => this.setState({ fetching_pdf: false }))
            .catch((error) => {
                this.setState({ fetching_pdf: false })
                window.showDialog(error)
            })
    }

    getOrderLabels = (orderIds, print) => {
        this.setState({ fetching_pdf: true })
        this.props
            .downloadOrderAction(orderIds[0], print)
            .then(() => this.setState({ fetching_pdf: false }))
            .catch((error) => {
                this.setState({ fetching_pdf: false })
                window.showDialog(error)
            })
    }

    openInfoDialog = () => {
        window.showDialog({ message: strings.infoDialogText, title: ' ' })
    }

    goToBillingInformation = () => {
        this.props.history.push({
            pathname: routes.billingInformation.path,
        })
    }

    viewOrder = (orderId) => {
        this.props.history.push({
            pathname: routes.tracking.path,
            state: { orderId: orderId },
        })
    }

    handleCheckAllOrders = (event) => {
        let rows = this.state.rows.map((x) => ({
            ...x,
            checked: event.target.checked,
        }))
        this.setState({ rows: rows })
    }

    handleCheckOrder = (event) => {
        let orderId = parseInt(event.target.name)
        let rows = this.state.rows.map((x) =>
            x.id === orderId ? { ...x, checked: event.target.checked } : x
        )
        this.setState({ rows: rows })
    }

    componentDidMount() {
        this.getStatus()
            .then(() => {
                this.getGroupReadyForCollect()
                this.getOrders();
            })
    }

    getFilterStateString(stateId) {
        return strings.orderStateFilter[getObjectKey(orderStateTypes, stateId)]
    }

    handleOrdersReady = (ordersIds) => {
        window.showDialog(
            {
                title: strings.orderReadyDialogTitle,
                message: strings.ordersReadyDialogText,
            },
            () => {
                orderReadyAll(ordersIds)
                    .then((response) => {
                        if (response.data.error.length > 0) {
                            window.showDialog(
                                {
                                    title: strings.orderReadyAllErrorTitle,
                                    message: strings.orderReadyAllError,
                                }
                            )
                        } else {
                            window.showDialog(
                                {
                                    title: strings.orderReadyAllSuccessTitle,
                                    message: strings.orderReadyAllSuccess,
                                },
                                () => {
                                    this.getOrders();
                                    window.location.reload()
                                }
                            )
                        }
                    })
                    .catch((error) => {
                        window.showDialog(error)
                    })
            },
            () => { }
        )
    }

    render() {
        let ordersReadyToPickUp = this.state.readyForCollect
        let minimumGroupToReadyForCollect = this.props.appStore.minimumGroupToReadyForCollect
        let remainingOrders = minimumGroupToReadyForCollect - this.state.ordersGroupedToReadyForCollect.length

        if (this.state.fetching_orders || this.state.fetching_pdf)
            return <Loader />

        return (
            <div>
                {this.state.status.status === statusTypes.Registered ? (
                    <div
                        className="alert alert-hover alert-danger"
                        role="alert"
                        style={{ cursor: 'pointer' }}
                        onClick={this.openInfoDialog}
                    >
                        <i>
                            <WarningIcon />
                        </i>
                        {strings.cantOperate}
                    </div>
                ) : this.state.status.status ===
                    statusTypes.PendingValidation ? (
                    <div
                        className="alert alert-hover alert-danger"
                        role="alert"
                        onClick={this.goToBillingInformation}
                    >
                        <i>
                            <WarningIcon />
                        </i>
                        {strings.pendingValidation}
                    </div>
                ) : this.state.status.status ===
                    statusTypes.CustomerDisabled ? (
                    <div className="alert alert-danger" role="alert">
                        <i>
                            <WarningIcon />
                        </i>
                        {strings.customerDisabled}
                    </div>
                ) : null}

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        alignItems: 'baseline',
                        marginTop: 10,
                    }}
                >
                    <TextField
                        label={strings.ordersFromDateLabel}
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        value={this.state.fromDate}
                        onChange={(e) =>
                            this.setState({ fromDate: e.target.value })
                        }
                        fullWidth
                        style={styles.field}
                    />
                    <TextField
                        label={strings.ordersToDateLabel}
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        value={this.state.toDate}
                        onChange={(e) =>
                            this.setState({ toDate: e.target.value })
                        }
                        fullWidth
                        style={styles.field}
                    />
                    <FormControl fullWidth style={styles.field}>
                        <InputLabel>{strings.orderTypesLabel}</InputLabel>
                        <Select
                            style={{ marginTop: 17 }}
                            value={this.state.orderTypeId || '0'}
                            onChange={(e) =>
                                this.setState({ orderTypeId: e.target.value })
                            }
                        >
                            <MenuItem value="0">
                                <i>{strings.allCamel}</i>
                            </MenuItem>
                            {Object.values(orderTypes).map((x) => (
                                <MenuItem key={x + ''} value={x}>
                                    {
                                        strings.orderTypes[
                                        getObjectKey(orderTypes, x)
                                        ]
                                    }
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth style={styles.field}>
                        <InputLabel>{strings.orderStateLabel}</InputLabel>
                        <Select
                            style={{ marginTop: 17 }}
                            value={this.state.orderStateId || '0'}
                            onChange={(e) =>
                                this.setState({ orderStateId: e.target.value })
                            }
                        >
                            <MenuItem value="0">
                                <i>{strings.allCamel}</i>
                            </MenuItem>
                            {orderStatesFilter.map((x) => (
                                <MenuItem key={x + ''} value={x}>
                                    {this.getFilterStateString(x)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        label={
                            <div>
                                <label style={{ marginRight: 5 }}>
                                    {strings.ordersOrderNumberLabel}
                                    <TooltipFontSizeMedium
                                        title={strings.ordersOrderNumberTooltip}
                                    >
                                        <InfoIcon
                                            style={{
                                                fontSize: 16,
                                                marginLeft: 4,
                                            }}
                                        />
                                    </TooltipFontSizeMedium>
                                </label>
                            </div>
                        }
                        placeholder={strings.ordersOrderNumberLabelPlaceholder}
                        InputLabelProps={{ shrink: true }}
                        value={this.state.orderNumber}
                        onChange={(e) =>
                            this.setState({ orderNumber: e.target.value })
                        }
                        fullWidth
                        style={styles.field}
                    />
                </div>
                <div style={styles.btnContainer}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.getOrders(1, undefined)}
                        fullWidth
                        disabled={this.state.fetching_orders}
                        style={styles.formBtn}
                    >
                        {strings.ordersSubmitButton}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.getOrdersForExport()
                        }}
                        fullWidth
                        disabled={this.state.fetching_orders}
                        style={styles.formBtn}
                    >
                        {strings.ordersExportButton}
                    </Button>
                </div>
                {
                    this.props.appStore.userPermissions.some((x) => x === 'shopPickup') && (minimumGroupToReadyForCollect > 1 && this.state.ordersGroupedToReadyForCollect.length > 0)
                        || this.state.ordersGroupedToReadyForCollect.length > 0 && ordersReadyToPickUp + this.state.ordersGroupedToReadyForCollect.length >= minimumGroupToReadyForCollect && minimumGroupToReadyForCollect > 1 ?
                        <div style={{ margin: '20px' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => this.handleOrdersReady(this.state.ordersGroupedToReadyForCollect)}
                                style={styles.formBtn}
                                disabled={
                                    (ordersReadyToPickUp + this.state.ordersGroupedToReadyForCollect.length >= minimumGroupToReadyForCollect && minimumGroupToReadyForCollect > 1)
                                        ? false
                                        : true
                                }
                            >
                                {strings.orderReadyConfirmPickUp.replace('{{ordersGrouped}}', this.state.ordersGroupedToReadyForCollect.length)}
                            </Button>
                            {ordersReadyToPickUp + this.state.ordersGroupedToReadyForCollect.length < minimumGroupToReadyForCollect ?
                                <Typography color='primary' variant="caption" display='block' style={{ marginLeft: '20px' }}>
                                    {strings.pickupLimit.replace('{{remainingOrders}}', remainingOrders)}
                                </Typography>
                                : null}
                        </div>
                        : null
                }
                <GridList
                    items={this.state.rows}
                    getOrderLabel={this.getOrderLabel}
                    getOrderLabels={this.getOrderLabels}
                    viewOrder={this.viewOrder}
                    handleCheckOrder={this.handleCheckOrder}
                    handleCheckAllOrders={this.handleCheckAllOrders}
                    actionDone={() => this.getOrders()}
                    showOrderReservable={this.props.appStore.userPermissions.some(
                        (x) => x === 'orderReserver'
                    )}
                    shopPickupAvailable={this.props.appStore.userPermissions.some(
                        (x) => x === 'shopPickup'
                    )}
                    showOrdersMenu={this.props.appStore.userPermissions.some(
                        (x) => x === 'ordersMenu'
                    )}
                    rowCount={this.state.totalRows}
                    pageIndex={this.state.paginatorPageIndex || 1}
                    onChangePage={(pageIndex) =>
                        this.getOrders(
                            pageIndex,
                            this.state.paginatorRowsPerPage
                        )
                    }
                    rowsPerPage={
                        this.state.paginatorRowsPerPage ||
                        localStorage.getItem('paginatorRowsPerPage') ||
                        10
                    }
                    onChangeRowsPerPage={(rowsPerPage) =>
                        this.getOrders(
                            this.state.paginatorPageIndex,
                            rowsPerPage
                        )
                    }
                    ordersGroupedToReadyForCollect={this.state.ordersGroupedToReadyForCollect}
                    ordersReadyToPickUp={ordersReadyToPickUp}
                />
            </div>
        )
    }
}

const mapDispatchToProps = {
    getOrdersAction,
    getGroupReadyForCollectAction,
    getOrdersForExportAction,
    downloadOrderAction,
    getStatusAction,
}
const mapStateToProps = (store) => ({ appStore: store.app })
export default connect(mapStateToProps, mapDispatchToProps)(Component)
